import { GlobalType } from '../Global'
import { produce } from 'immer'
import { SubscriptionState } from '@batical/types/src'
import { SubscriptionType } from './SubscriptionType'

export const initialSubscriptionState: SubscriptionState = {
  isAndroid: false,
  isIos: false,
  isStripe: false,
  expirationDate: 0,
  expirationDateStripe: 0,
  expirationDateDistributor: 0,
  isDistributor: false,
  offerBy: undefined,
  offerBySubscriptionId: undefined
}

export const subscriptionReducer = (state = initialSubscriptionState, action: SubscriptionAction) =>
  produce(state, draft => {
    switch (action.type) {
      case SubscriptionType.INIT_SUBSCRIPTION: {
        return {
          ...initialSubscriptionState,
          ...action.payload.data
        }
      }
      case SubscriptionType.UPDATE_EXPIRATION: {
        //TODO: Handle conflict with web and strip
        draft.expirationDate = action.payload.expirationDate
        draft.isIos = action.payload.platform === 'ios'
        draft.isAndroid = action.payload.platform === 'android'
        break
      }
      case GlobalType.CLEAR_LOADED_DATA:
        return { ...initialSubscriptionState }
    }
  })

export type SubscriptionAction =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | { type: SubscriptionType.INIT_SUBSCRIPTION; payload: { data: Partial<SubscriptionState> } }
  | { type: SubscriptionType.UPDATE_EXPIRATION; payload: { expirationDate: number; platform: string } }
